<rid-flash-counting
  (finished)="$router.navigate(['/mechanics/formule'])"
  [clusters]="3"
  [guessDuration]="3500"
  [numbers]="numbers()"
  [visibilityDurationPerDot]="300"
  class="h-dvh"
/>
